import { cn } from '@lemonenergy/lemonpie-3'
import type { HTMLAttributes } from 'react'
type CircularLoadingProps = HTMLAttributes<HTMLDivElement> & {
  size?: 'main' | 'larger' | 'largest' | 'small'
}

const CircularLoading = ({
  className,
  size = 'larger',
  ...props
}: CircularLoadingProps) => {
  const sizeMap = {
    main: 'size-main',
    larger: 'size-larger',
    largest: 'size-largest',
    small: 'size-small',
  }

  return (
    <div
      className={cn('inline-block relative', sizeMap[size], className)}
      {...props}
    >
      <div
        className={`box-border block absolute ${sizeMap[size]} border-[4px] border-solid bdr-strong rounded-[50%] border-b-transparent animate-spin`}
      ></div>
    </div>
  )
}

export default CircularLoading
